import React from "react";
import ReactHtmlParser from "react-html-parser";
import ButtonComp from "./ButtonComp";
import { useNavigate } from "react-router-dom";

// ================= ATOMS =================
const StatsItem = ({ value, highlight, label, index }) => (
  <div className="text-center px-1 px-sm-2 px-md-3 stats-item-responsive">
    {([1, 0].includes(index) || highlight === "+" || highlight === "%") ? (
      <div className="hero-title fw-800 FS48">
        {value}
        <span className="symbol-text-success">{highlight}</span>
      </div>
    ) : (
      <div className="hero-title fw-800 FS48">
        <span className="symbol-text-success">{highlight}</span>
        {value}
      </div>
    )}
    <div className="FS20FW500 text-gray-pricing plus-sans mt-1">{label}</div>
  </div>
);

// ================= MOLECULE =================
const ProfileCard = ({ profile }) => (
  <div className="profile-wrap position-relative">
    <div className={`${profile?.image.includes("Varun-sir-hero.webp") ? 'profile-card' : ''} border-0`}>
      <div className="card-body text-white p-3 p-sm-4">

        {profile?.stats?.length > 0 &&
          <div className="d-flex justify-content-between text-center pt-2 gap-1 gap-sm-2 flex-xl-nowrap flex-wrap">
            {profile?.stats.map((s, i) => (
              <div key={i} className="stats-blur-box flex-grow-1">
                <div
                  className="fw-800 FS32 text-success hero-title mb-0"
                  style={{ fontStyle: "unset" }}
                >
                  {s.value}
                </div>
                <span
                  className="FS12 fw-400"
                  style={{ color: "rgba(255, 255, 255, 0.45)" }}
                >
                  {s.label}
                </span>
              </div>
            ))}
          </div>
        }
      </div>
    </div>
  </div>
);

// ================= ORGANISM =================
const HeroSectionUpdatedSecond = ({ data, isCenter = false, extraClass = "" }) => {
  const navigate = useNavigate();
  return (
    <section className={`new-updated-hero-section position-relative ${extraClass}`}>
      <div className="hero-section text-white position-relative overflow-hidden">
        <div className="hero-bg" />

        <div className={`custom-container position-relative z-2 py-3 py-sm-4 pt-md-5 pb-md-5 ${isCenter ? 'pb-lg-5 mb-lg-5' : ''} mt-5 px-0`}>
          <div className="row align-items-center justify-content-center text-center g-3 g-md-4">
            {/* LEFT */}
            <div className="col-12 col-lg-8 mb-4 mb-lg-0">
              <span className="students-stat mb-2 mb-sm-3 d-inline-block">{data.badge}</span>

              {data.title && data.title()}

              <p
                className="mb-5 FS20FW500 fw-400"
                style={{ color: "rgba(222, 222, 222, 1)" }}
              >
                {data.subtitle && ReactHtmlParser(data.subtitle)}
              </p>

              <div className={`d-flex flex-column flex-sm-row justify-content-center gap-2 gap-sm-3 mb-5 ${isCenter ? 'pb-lg-4' : ''}`}>
                {data.btn_prepration && (
                  <ButtonComp
                    link={data.btn_prepration.onClick}
                    btnText={data.btn_prepration.text}
                    img="/images/web-new-images/new-dark-arrow.svg"
                  />
                )}

                {data.btn_outline && (
                  <button
                    className="border-btn gap-2 primary-btn w-auto w-sm-auto"
                    onClick={() => navigate(data.btn_outline.link)}
                    style={{ border: '1px solid #94C23C', background: 'transparent', color: '#94C23C' }}
                  >
                    {data.btn_outline.text}
                    <img
                      src={`/images/web-new-images/new-green-arrow.png`}
                      alt="Arrow"
                    />
                  </button>
                )}
              </div>

              <div className="d-flex align-items-center gap-3 d-none">
                <div className="d-flex">
                  {data.users.map((img, i) => (
                    <img
                      key={i}
                      src={img}
                      alt="user"
                      className="user-img"
                      style={{ marginLeft: i ? -12 : 0 }}
                    />
                  ))}
                </div>
                <small className="text-secondary">{data.trustText}</small>
              </div>
              <div className="d-flex align-content-center gap-3">
                  {data.appDownloadBtn && data.appDownloadBtn()}
              <div className="join-community d-flex flex-column flex-sm-row align-items-center justify-content-center justify-content-lg-start gap-3 gap-sm-5 gap-md-3">
                <div className="avatars d-flex">
                  {data.users.map((img, i) => (
                    <img
                      key={i}
                      src={img}
                      alt="user"
                      className="user-img avatar rounded-circle"
                    />
                  ))}
                </div>
                
              </div>
              </div>
            </div>

            <div style={isCenter ? { position: "absolute", top: "0px", left: "50%", transform: "translateX(-50%)", width: "100%", zIndex: 0 } : { position: "absolute", top: "-70px", right: "145px" }} className={`col-12 col-lg-4 profile-card-background ${isCenter ? 'centered-circle-bg' : ''} `}>
              <ProfileCard profile={data.profile} />
            </div>
          </div>
        </div>
      </div>
      {/* MIDDLE SECTION */}
      {data.middleSection && (
        <div
          style={{ bottom: "-96px", position: "absolute", left: "50%", transform: "translateX(-50%)", width: "90%", zIndex: 10 }}
          className="mt-5 mt-sm-4 mt-md-5 custom-container"
        >
          {data.middleSection()}
        </div>
      )}

      {/* STATS BAR */}
      {!data.middleSection && data.bottomStats && (
        <div
          style={{ bottom: "-80px" }}
          className="stats-bar mt-3 mt-sm-4 mt-md-5 p-2 p-sm-3 p-md-4 d-flex flex-wrap justify-content-between gap-2 gap-sm-3 custom-container"
        >
          {data.bottomStats.map((item, i) => (
            <StatsItem key={i} index={i} {...item} />
          ))}
        </div>
      )}
    </section>
  );
};

export default HeroSectionUpdatedSecond;
